import { render, staticRenderFns } from "./ECommerceShop.vue?vue&type=template&id=72da16e3&scoped=true"
import script from "./ECommerceShop.vue?vue&type=script&lang=js"
export * from "./ECommerceShop.vue?vue&type=script&lang=js"
import style0 from "./ECommerceShop.vue?vue&type=style&index=0&id=72da16e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da16e3",
  null
  
)

export default component.exports